module.exports = __webpack_public_path__ + "img/category-brand.3c1d4114.png";